/* @flow */

import React from 'react';
import DownloadCoachMarkScss from './DownloadCoachMark.scss';
import ChevronDown from '@react/react-spectrum/Icon/ChevronDown';
import Alias from '@react/react-spectrum/Icon/Alias';
import AppsUtil from '../../utils/AppsUtil';
import DeviceDetectionUtil from '../../utils/DeviceDetectionUtil';
import {Toast} from '@react/react-spectrum/Toast';

type Props = {
	intl: Object,
	isNewDesign?: boolean,
	showInGreen?: boolean,
	isActivationTest?: boolean,
	upArrow?: boolean,
	isAllAppsPicker?: boolean,
	ccDownloadPage?: boolean,
	isNonInstallerFileDownload?: boolean
};

const renderCoachMark = (props: Props) => {
	if (props.isActivationTest) {
		return (<ChevronDown key='ChevronDownIcon' size='XXL' className={DownloadCoachMarkScss.chevronDownIcon}/>);
	}
	if (props.isNewDesign) {
		let message = 'ccd.installer.banner.text';
		if (!props.upArrow) {
			message = 'ccd.installer.banner.text_down';
		}
		return (
			[<Alias key='AliasIcon' size='XXL' className={DownloadCoachMarkScss.aliasIcon}/>,
				<div key='coachmarkTitle' className={DownloadCoachMarkScss.popUp_title}>{props.intl.formatMessage({id: message})}</div>]
		);
	}
	if (props.isAllAppsPicker || props.ccDownloadPage) {
		return (
			<div >
				<Toast variant='info' className={DownloadCoachMarkScss.allAppsPickerContainer}>
					{props.intl.formatMessage({
						id: props.isNonInstallerFileDownload ? 'apps.loggedOutCampaign.openFile.coachMark' : 'apps.allAppsAppPicker.coachMark'
					})}
				</Toast>
			</div>
		);
	}
	return ([<div key='coachmark' className={DownloadCoachMarkScss.popUp_arrow}>
		<div className={DownloadCoachMarkScss.popUpRectangle}/>
		<div className={DownloadCoachMarkScss.popUpTriangle}/>
	</div>,
	<div key='coachmarkTitle' className={DownloadCoachMarkScss.popUp_title}>{props.intl.formatMessage({id: 'apps.installer.banner.text'})}</div>]
	);
};

const DownloadCoachMark = (props: Props) => {
	const safariClass = DeviceDetectionUtil.isSafari() ? DownloadCoachMarkScss.UpArrow : '';
	const firefoxClass = DeviceDetectionUtil.isFirefox() ? DownloadCoachMarkScss.Center : '';
	const ieEdgeClass = DeviceDetectionUtil.isEdgeOrIE() ? DownloadCoachMarkScss.CenterWithBottomOffset : '';
	const activationTestClass = props.isActivationTest ? `${DownloadCoachMarkScss.activationTestIconCoachMark} activationTestIconCoachMark` : '';
	const newDesignClass = props.isNewDesign ? DownloadCoachMarkScss.newDesignCoachMark : '';
	const greenBackgroundClass = props.showInGreen ? DownloadCoachMarkScss.installer_popUp_green : '';
	const isAllAppsPicker = props.isAllAppsPicker || props.ccDownloadPage ? DownloadCoachMarkScss.allAppsPicker : '';
	const className = `${DownloadCoachMarkScss.installer_help_container_popUp} ${safariClass} ${activationTestClass} ${newDesignClass} ${greenBackgroundClass} ${isAllAppsPicker} ${firefoxClass} ${ieEdgeClass}`;
	return (
		<div className={className} id='popUpInstaller'>
			{renderCoachMark({...props, upArrow: AppsUtil.isSafari()})}
		</div>);
};

export default DownloadCoachMark;
